import { useClient } from './api-client';
import { useMutation, useQuery } from 'react-query';
import { isPlayGroundMode } from '../utils/CookieToken';

const useQueryCall = (
  queryConfig,
  endPoint,
  queryKeys,
  queryFunction = null,
) => {
  const client = useClient();

  const {
    data,
    dataUpdatedAt,
    error,
    errorUpdatedAt,
    failureCount,
    isError,
    isFetched,
    isFetchedAfterMount,
    isFetching,
    isIdle,
    isLoading,
    isLoadingError,
    isPlaceholderData,
    isPreviousData,
    isRefetchError,
    isRefetching,
    isStale,
    isSuccess,
    refetch,
    remove,
    status,
  } = useQuery({
    queryKey: queryKeys,
    queryFn: queryFunction
      ? queryFunction
      : () =>
          client(
            `${isPlayGroundMode ? `playground` : `lifeline_apis`}/${endPoint}`,
          ),
    ...queryConfig,
  });
  return {
    data,
    dataUpdatedAt,
    error,
    errorUpdatedAt,
    failureCount,
    isError,
    isFetched,
    isFetchedAfterMount,
    isFetching,
    isIdle,
    isLoading,
    isLoadingError,
    isPlaceholderData,
    isPreviousData,
    isRefetchError,
    isRefetching,
    isStale,
    isSuccess,
    refetch,
    remove,
    status,
  };
};
function useMutationCall(
  mutationConfig,
  endPoint,
  mutationKeys,
  meta = {},
  mutationFunction = null,
) {
  const client = useClient();
  const {
    data,
    error,
    isError,
    isIdle,
    isLoading,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
  } = useMutation({
    mutationKey: [...mutationKeys],
    mutationFn: mutationFunction
      ? mutationFunction
      : (data) =>
          client(
            `${isPlayGroundMode ? `playground` : `lifeline_apis`}/${endPoint}`,
            { data },
          ),
    ...mutationConfig,
    meta: meta,
  });

  return {
    data,
    error,
    isError,
    isIdle,
    isLoading,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
  };
}

export { useQueryCall, useMutationCall };
